<script>
export default {
  name: 'TwGridDual'
}
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
    <slot />
  </div>
</template>

<style scoped>

</style>
